import React from 'react';
import { motion } from 'framer-motion';
const photos = ['https://cdn.magicpatterns.com/uploads/mrQojytGVeC6Z86GSctznq/bwc1.jpg', 'https://cdn.magicpatterns.com/uploads/p9SsNcEuvmL3REnGKDXPSL/bwc2.jpg', 'https://cdn.magicpatterns.com/uploads/dXwLJpZ1KfzKEpGBd4Bhnn/bwc3.jpg'];
export function Gallery() {
  return <section id="gallery" className="py-24 bg-gray-50" data-id="element-42">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-43">
        <div className="text-center mb-16" data-id="element-44">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-bold text-ocean-900 mb-4" data-id="element-45">
            Our Work
          </motion.h2>
          <motion.div initial={{
          opacity: 0,
          scale: 0.8
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="w-24 h-1 bg-sun-500 mx-auto rounded-full" data-id="element-46"></motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-47">
          {photos.map((photo, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="rounded-2xl overflow-hidden shadow-xl shadow-ocean-900/10 group aspect-[4/5] md:aspect-square" data-id="element-48">
              <img src={photo} alt={`BWC Decking Work ${index + 1}`} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-49" />
            </motion.div>)}
        </div>
      </div>
    </section>;
}